import { ProjectionHelper } from '../../tools/ProjectionHelper.js';
import { GalleryMarkerBase } from "./GalleryMarkerBase.js";

export class ThreePointViewMarker extends GalleryMarkerBase {

    constructor(mapAdapter, markerFactory, points, options) {
        super(mapAdapter, markerFactory, points, options);
        this.poly = null;
        this.fillPoly = null;
    }

    draw(map) {
        this.poly = this.mapAdapter.createPolygon({
            map,
            strokeColor: this.options.color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            fillOpacity: 0
        });

        this.fillPoly = this.mapAdapter.createPolygon({
            map,
            fillColor: this.options.color,
            strokeOpacity: 0,
            fillOpacity: 0.2
        });

        const projectionHelper = new ProjectionHelper(map);

        // Warte auf Projection (einmalig per 'ready'-Event)
        // ToDo: adapter verwenden
        google.maps.event.addListenerOnce(projectionHelper.getOverlay(), 'ready', () => {
            const [p0, p1, p2] = this.points;
            const baseLatLng = this.mapAdapter.createLatLng(p0.lat, p0.lng);

            // Richtungspunkte (Vektoren vom Ursprung)
            const vec1 = {
                x: this._vectorDelta(projectionHelper, p0, p1),
                y: this._vectorDelta(projectionHelper, p0, p1, false)
            };
            const vec2 = {
                x: this._vectorDelta(projectionHelper, p0, p2),
                y: this._vectorDelta(projectionHelper, p0, p2, false)
            };

            let v1Length = Math.sqrt(Math.pow(vec1.x, 2) + Math.pow(vec1.y, 2));
            let v2Length = Math.sqrt(Math.pow(vec2.x, 2) + Math.pow(vec2.y, 2));

            // Normierung & Multiplikation

            const scale = v1Length > v2Length ? v1Length : v2Length; // Pixel-Abstand
            const n1 = this._scaleVector(vec1, scale);
            const n2 = this._scaleVector(vec2, scale);

            const tip1 = projectionHelper.offsetLatLng(baseLatLng, n1.x, n1.y);
            const tip2 = projectionHelper.offsetLatLng(baseLatLng, n2.x, n2.y);

            const path = [baseLatLng, tip1, baseLatLng, tip2, baseLatLng];
            this.poly.setPath(path);
            this.fillPoly.setPath([tip1, baseLatLng, tip2]);

            projectionHelper.destroy();

            let latLng = this.mapAdapter.createLatLng(this.points[0]);
            const marker = this.createOriginMarker(latLng);
            this.drawnElements.push(marker);
        });
    }

    _vectorDelta(helper, origin, target, isX = true) {
        const oPx = helper.latLngToPixel(this.mapAdapter.createLatLng(origin.lat, origin.lng));
        const tPx = helper.latLngToPixel(this.mapAdapter.createLatLng(target.lat, target.lng));
        return (isX ? tPx.x - oPx.x : tPx.y - oPx.y);
    }

    _scaleVector(vector, scale) {
        const len = Math.sqrt(vector.x ** 2 + vector.y ** 2);
        if (len === 0) return { x: 0, y: 0 };
        return {
            x: (vector.x / len) * scale,
            y: (vector.y / len) * scale
        };
    }

    clear() {
        if (this.poly) this.poly.setMap(null);
        if (this.fillPoly) this.fillPoly.setMap(null);
        super.clear();
    }
}
